import script from "./ImageCropper.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageCropper.vue?vue&type=script&setup=true&lang=ts"

import "./ImageCropper.vue?vue&type=style&index=0&id=2be7b667&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be7b667"]])

export default __exports__